export default "__VITE_ASSET__DuCIwCEw__"